// extracted by mini-css-extract-plugin
export default {"triangleDown":"Pricing_triangleDown__R3uDY","Header":"Pricing_Header__faVlA"};